"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowConfirmBase = void 0;
const Entities_1 = require("../../Entities");
class ShowConfirmBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (castPayload.title === undefined ||
            castPayload.message === undefined ||
            castPayload.confirmButtonLabel === undefined ||
            castPayload.cancelButtonLabel === undefined ||
            castPayload.confirmCallback === undefined ||
            castPayload.cancelCallback === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'SHOW_CONFIRM';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const castPayload = this.castPayloadV1(payload);
                this.action(castPayload);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.ShowConfirmBase = ShowConfirmBase;
